/* cart-drawer-aed.js — currency clarity in the cart drawer for non-AED (Nova) visitors.

   WHY: the store charges AED only (enabled_presentment_currencies = ['AED']). Nova
   converts on-site prices to the visitor's currency for display, but the Shopify
   checkout always shows AED. A USD/EUR browser therefore meets an unexpected AED
   total at checkout = currency shock. This box pre-empts it.

   WHAT (2026-06-01): a DUAL-currency line mirroring the buy-now popup box, e.g.
   "EUR 249.99 ≈ AED 1,069.99" with small ISO code labels. The AED side is the
   ground truth (Shopify /cart.js total, always AED). The visitor-currency side is
   the Nova-converted drawer total (.totals__total-value).

   GATE = the RENDERED drawer total, NOT Nova storage keys. The label reads
   Nova's sessionStorage bacurr_user_cur (the currency it shows, geo or picked)
   first (2026-10-27). The keys
   (baCurrency / bacurr_currency / bacurrGeoCurrency / config.user_curr) are
   unreliable — they are empty for many geo-detected visitors and even for some
   manual picks, so the box silently never appeared (bug found 2026-06-01: a live
   €249.99 cart showed no box). Nova rewrites .totals__total-value to the visitor's
   currency, so that string IS the ground truth: non-AED total => show the box;
   AED (or not yet converted) => hide. Same principle as snippets/sticky-atc-bar.liquid.

   RE-RENDER SAFE: the drawer replaces #CartDrawer innerHTML on every cart change,
   which wipes any inline script. So this lives in a once-loaded asset and
   re-populates via a MutationObserver on the stable <cart-drawer> host. Distinct
   element id (#pc-drawer-aed-preview) avoids colliding with the modal's
   #pc-ship-aed-preview when both render on /cart. Loop-guarded by a composite
   signature (AED total + visitor total): our write to #pc-drawer-aed-preview
   changes neither input, so the observer settles instead of looping, and upgrades
   the box the moment Nova converts the total. */
(function () {
  // Resolve a visitor ISO code from a RENDERED price string (symbol/prefix map for
  // the common currencies; null for a bare "$" or anything unrecognised). Mirrors
  // snippets/buy-now-confirm.liquid so the two surfaces look identical.
  function isoFromPrice(p) {
    if (!p) return null;
    var s = String(p);
    var m = s.match(/\b(USD|EUR|GBP|JPY|CNY|INR|KRW|RUB|TRY|THB|PHP|VND|ILS|NGN|BRL|SAR|KWD|BHD|QAR|OMR|CAD|AUD|NZD|SGD|HKD|CHF|SEK|NOK|DKK|PLN|ZAR|MXN|EGP|MYR|IDR)\b/i);
    if (m) return m[1].toUpperCase();
    if (/US\$/.test(s)) return 'USD';
    if (/CA\$/.test(s)) return 'CAD';
    if (/NZ\$/.test(s)) return 'NZD';
    if (/A\$/.test(s)) return 'AUD';
    if (/HK\$/.test(s)) return 'HKD';
    if (/S\$/.test(s)) return 'SGD';
    if (/R\$/.test(s)) return 'BRL';
    if (/€/.test(s)) return 'EUR';
    if (/£/.test(s)) return 'GBP';
    if (/₹/.test(s)) return 'INR';
    if (/₩/.test(s)) return 'KRW';
    if (/₽/.test(s)) return 'RUB';
    if (/₺/.test(s)) return 'TRY';
    if (/฿/.test(s)) return 'THB';
    if (/₱/.test(s)) return 'PHP';
    if (/₫/.test(s)) return 'VND';
    if (/₪/.test(s)) return 'ILS';
    if (/₦/.test(s)) return 'NGN';
    if (/¥/.test(s)) return 'JPY';
    return null;
  }

  // Visitor ISO code for the label. TRUE active currency first: Nova's IP-geo can
  // DISPLAY a currency outside its 18-item dropdown (e.g. HKD), in which case
  // #baCurrSelector defaults to USD and would mislabel the card "USD". So read
  // baCurr.config.user_curr + our geo/manual storage BEFORE the dropdown selector;
  // the rendered-symbol parse and selector/chip are last-resort fallbacks. Never AED.
  function visitorCode(shown) {
    try { var uc = window.baCurr && baCurr.config && baCurr.config.user_curr; if (uc && /^[A-Za-z]{3}$/.test(uc) && uc.toUpperCase() !== 'AED') return uc.toUpperCase(); } catch (e) {}
    try {
      // Nova's bacurr_user_cur is the currency it is SHOWING (geo-applied or
      // picked by hand); bacurrGeoCurrency is only the location guess, so a
      // visitor geo'd to USD who picked CAD was labelled "USD $900.55".
      var s = null;
      try { s = JSON.parse(sessionStorage.getItem('bacurr_user_cur') || 'null'); } catch (e3) {}
      s = typeof s === 'string' && /^[A-Za-z]{3}$/.test(s) ? s.toUpperCase() : null;
      if (!s) s = localStorage.getItem('baCurrency') || localStorage.getItem('bacurr_currency');
      if (!s) { var raw = sessionStorage.getItem('bacurrGeoCurrency'); if (raw) { try { s = JSON.parse(raw); } catch (e2) { s = raw; } } }
      if (s && typeof s === 'object') s = s.currency || s.code || null;
      if (typeof s === 'string' && /^[A-Za-z]{3}$/.test(s) && s.toUpperCase() !== 'AED') return s.toUpperCase();
    } catch (e) {}
    var code = isoFromPrice(shown);
    if (code) return code;
    try {
      var sel = document.getElementById('baCurrSelector');
      if (sel && /^[A-Za-z]{3}$/.test(sel.value) && sel.value.toUpperCase() !== 'AED') return sel.value.toUpperCase();
    } catch (e) {}
    var chosen = document.querySelector('.ba-chosen');
    if (chosen) { var t = (chosen.textContent || '').trim().toUpperCase(); if (/^[A-Z]{3}$/.test(t) && t !== 'AED') return t; }
    return null;
  }

  // The label already names the currency: drop the same ISO code from the
  // rendered price ("QAR 2,357.33", or "$900.55 CAD" when Nova shows codes) so
  // the box never reads "CAD $900.55 CAD".
  function withoutCode(text, code) {
    if (!code) return text;
    var out = String(text).replace(new RegExp('\\s*\\b' + code + '\\b\\s*', 'i'), ' ').trim();
    return /[0-9]/.test(out) ? out : text;
  }

  function codeLabel(code) {
    var s = document.createElement('span');
    s.textContent = code;
    s.style.cssText = 'font-size:0.85em;font-weight:700;color:#5a5648;letter-spacing:0.04em;margin-right:0.3rem;';
    return s;
  }

  // The Nova-converted drawer total string, or '' if absent. Scoped to #CartDrawer
  // so we never read the /cart page footer total when both are present.
  function visitorTotalText() {
    var el = document.querySelector('#CartDrawer .totals__total-value');
    return el ? (el.textContent || '').trim() : '';
  }
  function isNonAed(t) {
    return !!(t && /[0-9]/.test(t) && !/Dhs|AED|د\.إ/i.test(t));
  }

  var lastSig = null;

  function populate() {
    var el = document.getElementById('pc-drawer-aed-preview');
    if (!el) return;
    var shown = visitorTotalText();
    // Gate on the rendered total (ground truth). AED or not-yet-converted => hide.
    if (!isNonAed(shown)) { el.hidden = true; lastSig = null; return; }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.total_price || cart.currency !== 'AED') return;
        var el2 = document.getElementById('pc-drawer-aed-preview');
        if (!el2) return;
        // Re-read in case Nova re-rendered during the fetch.
        var shown2 = visitorTotalText();
        if (!isNonAed(shown2)) { el2.hidden = true; lastSig = null; return; }
        var amount = cart.total_price / 100; // Shopify Cart API returns cents
        var aedFmt;
        try {
          aedFmt = new Intl.NumberFormat('en-AE', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
          }).format(amount);
        } catch (e) { aedFmt = amount.toFixed(2); }

        // Composite guard: re-render when the AED total OR the visitor total changes;
        // our write below alters neither, so the observer settles (no loop).
        var sig = cart.total_price + '|' + shown2;
        if (sig === lastSig && !el2.hidden) return;
        lastSig = sig;

        // Dual line: [ISO] visitorTotal ≈ [ISO] AED total. The visitor's own
        // currency carries the weight; the AED charge sits beside it, quieter.
        el2.textContent = '';
        var vc = visitorCode(shown2);
        var primary = document.createElement('span');
        primary.className = 'pc-aed-primary';
        if (vc) primary.appendChild(codeLabel(vc));
        primary.appendChild(document.createTextNode(withoutCode(shown2, vc)));
        el2.appendChild(primary);
        var approx = document.createElement('span');
        approx.className = 'pc-aed-approx';
        approx.textContent = '≈';
        el2.appendChild(approx);
        var secondary = document.createElement('span');
        secondary.className = 'pc-aed-secondary';
        secondary.appendChild(codeLabel('AED'));
        secondary.appendChild(document.createTextNode(aedFmt));
        el2.appendChild(secondary);
        // Sub-note explains the two numbers (mirrors the buy-now popup box): the
        // home-currency figure is the converted one at the latest rate, so the AED
        // beside it reads as the firm amount.
        var note = document.createElement('span');
        note.className = 'pc-aed-note';
        note.textContent = 'Same price, just shown in your currency.';
        el2.appendChild(note);
        el2.hidden = false;
      })
      .catch(function () {});
  }

  var t;
  function debounced() { clearTimeout(t); t = setTimeout(populate, 150); }

  function init() {
    populate(); // initial server-rendered drawer
    var host = document.querySelector('cart-drawer');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(debounced).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
